import commonUrls from './urls';

export const clientPermission = {
  urls: [...commonUrls],
  excludeUrls: [],
  hasNotification: true,
};
